import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useAppDispatch from 'hooks/useAppDispatch';
import useAppSelector from 'hooks/useAppSelector';
import { selectOrigin, selectViewMode } from 'store/reducers/navigationSlice';
import { returnSelectors, searchItemsStringSet } from 'store/reducers/returnSlice';
import { getStatusInfo } from 'utils/helpers';
import { useTranslation } from 'react-i18next';

const useGoBackNavigation = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { status } = useParams();
    const { type: statusType } = getStatusInfo(status, t);

    const dispatch = useAppDispatch();
    const origin = useAppSelector(selectOrigin);
    const viewMode = useAppSelector(selectViewMode);

    const { currentPage } = useAppSelector(returnSelectors.selectSearchReturnPageInfo);

    return useCallback(() => {
        if (viewMode === 'batch-returns') {
            navigate(-1);
            return;
        }

        if (origin === 'barcode') {
            navigate('/barcode');
            dispatch(searchItemsStringSet(''));
            return;
        }

        if (origin === 'search') {
            navigate('/');
            dispatch(searchItemsStringSet(''));
            return;
        }

        if (origin) {
            navigate(`/returns/${origin}`, {
                state: { pageinationPage: currentPage ?? 1 },
            });
            return;
        }

        // Default behavior for returns pages - go back in history
        navigate(-1);
    }, [origin, navigate, currentPage, dispatch, statusType]);
};

export default useGoBackNavigation;
